export const allowedWhiteLabeledDomains = ['https://app.intellishift.com'];
